import styled from 'styled-components';

interface ISpinnerLogoDefaultBoxProps {
    isRTL?: boolean;
}

export const SpinnerLogoDefaultBox = styled.div<ISpinnerLogoDefaultBoxProps>`
    position: absolute;
    top: 50px;
    left: 50px;
    bottom: 0;
    right: 0;
    z-index: 5;
    background-image: url("${props => props.theme.images.spriteSheet.toString()}");
    width: 80px;
    height: 80px;
    background-position: -823px -352px;
`;